import React from "react";
import styles from "./Leaderboard.module.css";

// 👶🏽 Muslim names (100 boys + 100 girls approx)
const names = [
  "Ahmed",
  "Fatima",
  "Ali",
  "Zainab",
  "Omar",
  "Ayesha",
  "Hassan",
  "Mariam",
  "Usman",
  "Noor",
  "Bilal",
  "Hina",
  "Saad",
  "Iqra",
  "Imran",
  "Sana",
  "Yasir",
  "Bushra",
  "Farhan",
  "Khadija",
  "Asad",
  "Hafsa",
  "Danish",
  "Amna",
  "Zubair",
  "Laiba",
  "Tariq",
  "Rimsha",
  "Waleed",
  "Anum",
  "Salman",
  "Zoya",
  "Hamza",
  "Sidra",
  "Rashid",
  "Mehwish",
  "Adeel",
  "Momal",
  "Raza",
  "Hira",
  "Adnan",
  "Nimra",
  "Faizan",
  "Areeba",
  "Kashif",
  "Nida",
  "Shahid",
  "Maha",
  "Noman",
  "Aqsa",
  "Taha",
  "Huma",
  "Zeeshan",
  "Sehrish",
  "Junaid",
  "Fiza",
  "Naeem",
  "Alishba",
  "Faraz",
  "Neha",
  "Rauf",
  "Aimen",
  "Sarmad",
  "Aleena",
  "Hammad",
  "Kinza",
  "Arsalan",
  "Sumbul",
  "Rizwan",
  "Mahnoor",
  "Kamran",
  "Rida",
  "Amir",
  "Eman",
  "Qasim",
  "Sheza",
  "Basit",
  "Iqra",
  "Nashit",
  "Tania",
  "Rehan",
  "Sania",
  "Shan",
  "Tuba",
  "Jawad",
  "Zainab",
  "Fahad",
  "Ayat",
  "Nouman",
  "Fariha",
  "Ahsan",
  "Uzma",
  "Muaz",
  "Hania",
  "Ibrahim",
  "Anaya",
  "Moiz",
  "Eshal",
  "Abdullah",
  "Yusra",
];

// 🎲 Utility to generate 200 random users
const generateUsers = () => {
  return Array.from({ length: 200 }, () => ({
    name: names[Math.floor(Math.random() * names.length)],
    score: Math.floor(Math.random() * 500) + 100, // 100 - 599
    avatar: "https://cdn-icons-png.flaticon.com/128/9131/9131529.png",
  }));
};

const getRandomUnique = (arr, count) => {
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const NewLeaderboard = () => {
  const allUsers = generateUsers();

  // Get 3 top players and sort descending
  const topThree = getRandomUnique(allUsers, 3).sort(
    (a, b) => b.score - a.score
  );

  // Get 4 random others
  const others = getRandomUnique(
    allUsers.filter((u) => !topThree.includes(u)),
    4
  );

  const topScore = topThree[0].score;

  return (
    <div className={styles.leaderboardContainer}>
      <div className={styles.topThree}>
        {topThree.map((user, index) => (
          <div key={index} className={styles.topUser}>
            <div
              className={
                user.score === topScore ? styles.avatarTop : styles.avatar
              }
            >
              {user.name.charAt(0)}
            </div>
            {/* <img
              src={user.avatar}
              alt={user.name}
              className={
                user.score === topScore ? styles.avatarTop : styles.avatar
              }
            /> */}
            {user.score === topScore && (
              <img
                src="https://cdn-icons-png.flaticon.com/256/9674/9674584.png"
                alt="crown"
                className={styles.crownIcon}
              />
            )}
            <p
              className={
                user.score === topScore ? styles.topScorename : styles.name
              }
            >
              {user.name}
            </p>
            <h5
              className={
                user.score === topScore ? styles.topScorescore : styles.score
              }
            >
              {user.score}
            </h5>
          </div>
        ))}
      </div>

      <div className={styles.others}>
        {others.map((user, index) => (
          <div key={index} className={styles.otherUser}>
            <div
              className={
                user.score === topScore ? styles.avatarTop : styles.avatar
              }
            >
              {user.name.charAt(0)}
            </div>

            <div className={styles.name}>{user.name}</div>
            <div className={styles.score}>{user.score}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewLeaderboard;
